var navigation = {
    logout: "Logout",
    welcome:"Welcome",
    home:"Home",
    registerbooking:"Register a Booking",
    track:"Track and Redeem",
    details:"Details and FAQs",
    language:"Español",
    changepass: "Change Password",
    reservehotel:"Reserve Hotel",
    webinar:"Training Academy"
}
module.exports = navigation





